import React from "react";
import {PolicySection} from "./PolicyModal.jsx";
import {openWindow} from "../../http/WindowOpener.jsx";
import {MainServices} from "../../consts.js";

export const generatePolicy = (isVoucher, serviceName) => {
    const serviceNameToPolicy = {
        [MainServices.HAPPY_HOURS]: [
            <PolicySection
                key="delivery"
                title="מדיניות משלוחים"
                sections={[
                    {
                        policies: [
                            "אין באפשרותנו להתחייב על שעת אספקה מדויקת במסגרת חלון האספקה שהוגדר בהזמנה. אם תבקשו לתאם שעה ספציפית בהערות, נעשה את מירב המאמצים, אך איננו יכולים להבטיח זאת.",
                            "אם איש הקשר אינו זמין בזמן האספקה, המשלוח יושאר בכתובת שצוינה בעת ההזמנה.",
                            "אם לא ניתן להשאיר את המשלוח בכתובת שהוזנה, תחויבו במלוא סכום ההזמנה.",
                            "מחיר השילוח עשוי להשתנות במקרים מיוחדים תוך עדכון ואישור הלקוח."
                        ]
                    }
                ]}
            />,
            <PolicySection
                key="cancel"
                title="מדיניות ביטולים"
                sections={[
                    {
                        policies: [
                            "ניתן לבטל הזמנה ולקבל החזר כספי מלא אם מתקיים אחד מהתנאים הבאים:",
                            "ביטול ההזמנה לפחות 7 ימים לפני תאריך האספקה.",
                            "ביטול הזמנה תוך 24 שעות מרגע מביצוע ההזמנה בתוך שעות הפעילות (18:00-08:00)"
                        ]
                    },
                    ...(isVoucher
                        ? [
                              {
                                  description: "לא ניתן לערוך או לבטל שובר לאחר הפקתו ושליחתו אל הנמען"
                              }
                          ]
                        : [])
                ]}
            />,
            <PolicySection
                key="changes"
                title="מדיניות שינויים"
                sections={[
                    {
                        policies: [
                            "ניתן לבצע שינויים בהזמנה אם מתקיים אחד מהתנאים הבאים:",
                            "שינוי בהזמנה עד 72 שעות לפני תאריך האספקה.",
                            "שינוי בהזמנה תוך 24 שעות ממועד אישור מביצוע ההזמנה בתוך שעות הפעילות (18:00-08:00)"
                        ]
                    }
                ]}
            />
        ],
        [MainServices.PACKAGES]: [
            <PolicySection
                key="delivery"
                title="מדיניות משלוחים"
                sections={[
                    {
                        policies: [
                            "אין באפשרותנו להתחייב על שעת אספקה מדויקת במסגרת חלון האספקה שהוגדר בהזמנה. אם תבקשו לתאם שעה ספציפית בהערות, נעשה את מירב המאמצים, אך איננו יכולים להבטיח זאת.",
                            "אם איש הקשר אינו זמין בזמן האספקה, המשלוח יושאר בכתובת שצוינה בעת ההזמנה.",
                            "אם לא ניתן להשאיר את המשלוח בכתובת שהוזנה, תחויבו במלוא סכום ההזמנה.",
                            "מחיר השילוח עשוי להשתנות במקרים מיוחדים תוך עדכון ואישור הלקוח."
                        ]
                    }
                ]}
            />,
            <PolicySection
                key="cancel"
                title="מדיניות ביטולים"
                sections={[
                    {
                        policies: [
                            "ניתן לבטל הזמנה ולקבל החזר כספי מלא אם מתקיים אחד מהתנאים הבאים:",
                            "ביטול ההזמנה לפחות 7 ימים לפני תאריך האספקה.",
                            "ביטול הזמנה תוך 24 שעות מרגע מביצוע ההזמנה בתוך שעות הפעילות (18:00-08:00)"
                        ]
                    },
                    ...(isVoucher
                        ? [
                              {
                                  description: "לא ניתן לערוך או לבטל שובר לאחר הפקתו ושליחתו אל הנמען"
                              }
                          ]
                        : [])
                ]}
            />,
            <PolicySection
                key="changes"
                title="מדיניות שינויים"
                sections={[
                    {
                        policies: [
                            "ניתן לבצע שינויים בהזמנה אם מתקיים אחד מהתנאים הבאים:",
                            "שינוי בהזמנה עד 72 שעות לפני תאריך האספקה.",
                            "שינוי בהזמנה תוך 24 שעות ממועד אישור מביצוע ההזמנה בתוך שעות הפעילות (18:00-08:00)"
                        ]
                    }
                ]}
            />
        ],
        [MainServices.WORKSHOPS]: [
            <PolicySection
                key="delivery"
                title="מדיניות משלוחים"
                sections={[
                    {
                        policies: [
                            "אין באפשרותנו להתחייב על שעת אספקה מדויקת במסגרת חלון האספקה שהוגדר בהזמנה. אם תבקשו לתאם שעה ספציפית בהערות, נעשה את מירב המאמצים, אך איננו יכולים להבטיח זאת.",
                            "אם איש הקשר אינו זמין בזמן האספקה, המשלוח יושאר בכתובת שצוינה בעת ההזמנה.",
                            "אם לא ניתן להשאיר את המשלוח בכתובת שהוזנה, תחויבו במלוא סכום ההזמנה.",
                            "מחיר השילוח עשוי להשתנות במקרים מיוחדים תוך עדכון ואישור הלקוח."
                        ]
                    }
                ]}
            />,
            <PolicySection
                key="cancel"
                title="מדיניות ביטולים"
                sections={[
                    {
                        policies: [
                            "ניתן לבטל הזמנה ולקבל החזר כספי מלא אם מתקיים אחד מהתנאים הבאים:",
                            "ביטול ההזמנה לפחות 7 ימים לפני תאריך האספקה.",
                            "ביטול הזמנה תוך 24 שעות מרגע מביצוע ההזמנה בתוך שעות הפעילות (18:00-08:00)"
                        ]
                    },
                    ...(isVoucher
                        ? [
                              {
                                  description: "לא ניתן לערוך או לבטל שובר לאחר הפקתו ושליחתו אל הנמען"
                              }
                          ]
                        : [])
                ]}
            />,
            <PolicySection
                key="changes"
                title="מדיניות שינויים"
                sections={[
                    {
                        policies: [
                            "ניתן לבצע שינויים בהזמנה אם מתקיים אחד מהתנאים הבאים:",
                            "שינוי בהזמנה עד 72 שעות לפני תאריך האספקה.",
                            "שינוי בהזמנה תוך 24 שעות ממועד אישור מביצוע ההזמנה בתוך שעות הפעילות (18:00-08:00)"
                        ]
                    }
                ]}
            />
        ]
    };
    return serviceNameToPolicy[serviceName];
};

export const systemPolicy = (
    <>
        <span>אני מסכימ/ה לתנאי השימוש</span>
        <a onClick={() => openWindow("https://www.well-b.biz/terms-and-conditions")} style={{padding: "0 3px"}}>
            תנאי שימוש
        </a>
        <span>וכן לאיסוף מידע עלי ועל נושאי המידע שאת פרטיהם אכניס במהלך השימוש, בהתאם ל</span>
        <a onClick={() => openWindow("https://www.well-b.biz/privacy-policy")}>מדיניות פרטיות</a>
        <span>
            , בהם ניתן למצוא, בין השאר, פירוט על המידע הנאסף, מטרות עיבודו, למי עשוי להימסר, משך שמירתו, השלכות אי
            מסירתו והזכויות במידע
        </span>
    </>
);
